import React, {Component} from 'react';
import {observer, Provider, inject } from "mobx-react";
import commentsStore from "../../../stores/commentsStore";
import historyVars from "../../../utils/historyVars";
import LastComboComments from "./LastComboComments";


class LastComboCommentsWithStore extends Component {
  constructor(props) {
    super(props);
    this._commentsStore=new commentsStore();
    if(this.props.standalone) {
      this._commentsStore.standalone = true;
    }
    if(this.props.editor_css) {
      this._commentsStore.editor_css = this.props.editor_css;
    }
    if(this.props.lang) {
      this.props.translateStore.lang=this.props.lang;
    }
    /*this._commentsStore.setRootElement(this.props.category, this.props.element);
    if(this.props.topic_starter) {
      this._commentsStore.setTopicStarter(this.props.topic_starter);
    }*/
    /*this._commentsStore.loadComments(true).then(()=>{
      this._commentsStore.moveToSelectedComment();
    });*/
  }

  componentWillUnmount() {
    this._commentsStore.destruct();
    historyVars.appendVars({ comment:"" });
  }
  componentDidMount() {
    if(!this.props.meStore.me.inited) {
      if(this.props.translateStore.lang == "ru") {
        this.props.translateStore.fetchTranslate();
      }
      this.props.meStore.fetchMe();
    }
  }

  render() {
    if(!this.props.meStore.me.inited || !this.props.translateStore.translate.inited) {
      return null;
    }
    return (
      <div>
        <Provider commentsStore={this._commentsStore}>
          <LastComboComments {...this.props} />
        </Provider>
      </div>
    )
  }
}

export default inject("meStore","translateStore")(observer(LastComboCommentsWithStore));